export const sleep = s => new Promise(r => setTimeout(r, s * 1000));

export const die = s => new Promise((_, r) => setTimeout(r, s * 1000));
